import { selectActualsData } from 'legacy/lut/features/partner360/configuration/selectors/selectActualsData'
import { useUserRoles } from 'legacy/lut/hooks/useUserRoles'
import { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'

import {
  DEFAULT_NETNDP,
  DEFAULT_NETNDP_PARTNER_USER,
  DEFAULT_NETNDP_PARTNER_USER_TYPES,
} from 'partner360/models/actualValueTypes'

export const useActualsData = (inititalActualsValueType: string = DEFAULT_NETNDP) => {
  const [actualsValueTypes, setActualsValueTypes] = useState<string[]>([])
  const [actualsValueType, setActualsType] = useState(inititalActualsValueType)

  const actualsData = useSelector(selectActualsData)
  const { isPartnerUser } = useUserRoles()

  useEffect(() => {
    if (isPartnerUser) {
      setActualsValueTypes(DEFAULT_NETNDP_PARTNER_USER_TYPES)
      setActualsType(DEFAULT_NETNDP_PARTNER_USER)
      return
    }

    setActualsValueTypes(actualsData.valueTypes)
    if (actualsData.valueTypeDefault) {
      setActualsType(actualsData.valueTypeDefault)
    }
  }, [isPartnerUser, actualsData.valueTypes, actualsData.valueTypeDefault])

  return {
    actualsValueType,
    actualsValueTypes,
    setActualsValueType: setActualsType,
  }
}
